// Era transition cinematic images
const ERA_TRANSITION_IMAGES = {
  1: 'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/65ad8e75485f2174f37a63083597504dbd354bc76d9a333e57f4f426e709a40d.jpeg',
  2: 'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/1fcf448f1db17f0d5e38f4f814d5d343eb34f22d27616cad54216ecf7c52c39c.jpeg',
  3: 'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/36e9ebd4ad85dc56f05804720f1698e3645777d245f6247282765f241319b9f1.jpeg',
  4: 'https://static.prod-images.emergentagent.com/jobs/9c53f98e-4805-48d9-9ea7-4a3815c7b3b1/images/62dfc37681fbcabfa07eec8457143311b887d0baa9142b80a1a43147b2f6b140.jpeg',
};

export default ERA_TRANSITION_IMAGES;
